import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DotsIcons } from '../../../assets/icons/feed/dots.svg';
import { ReactComponent as UserIcons } from '../../../assets/icons/feed/user.svg';
import { BottomSheet } from '../../../horizon-components/bottom-sheet/ui';
import { Modal } from '../../../horizon-components/Modal';
import { UserCommunity, UserCommunityRole } from '../../../models';
import { GetUserData } from '../../../utils/getUserData';
import { DropdownButton, IDropdownButton } from '../../../widgets/DropdownButton';
import { EditRoleModal } from '../../../widgets/EditRoleModal';

interface NetworkingDotsProps {
  className?: string;
  user?: GetUserData;
  member?: UserCommunity;
  onRole?: (role: UserCommunityRole) => void;
  onDemote?: () => void;
}

export const NetworkingDots = ({
  className,
  user,
  member,
  onRole,
  onDemote,
}: NetworkingDotsProps) => {
  const { t } = useTranslation(['translation']);
  const [buttons, setButtons] = useState<IDropdownButton[]>([]);
  const [isEditRole, setIsEditRole] = useState(false);

  useEffect(() => {
    const arr: IDropdownButton[] = [
      {
        title: t('buttons.Edit_a_role'),
        icon_right: <UserIcons />,
        onClick: () => hndlOpenEditRoleModal(),
      },
    ];
    setButtons(arr.filter(Boolean) as IDropdownButton[]);
  }, [t]);

  const hndlOpenEditRoleModal = () => {
    setIsEditRole(!isEditRole);
  };

  const hndlEditRole = (role: UserCommunityRole) => {
    setIsEditRole(!isEditRole);
    onRole?.(role);
  };

  const hndlDemote = () => {
    setIsEditRole(!isEditRole);
    onDemote?.();
  };

  return (
    <DropdownButton
      variant="highlighted"
      color="white"
      className={classNames('!w-[42px] !px-0', className)}
      buttons={buttons}
    >
      <DotsIcons />
      {window.innerWidth > 768 ? (
        <Modal
          title={t('buttons.Assign_a_role')}
          isOpen={isEditRole}
          onClose={hndlOpenEditRoleModal}
          maxWidth={400}
        >
          <EditRoleModal
            onSave={hndlEditRole}
            onDemote={hndlDemote}
            user={user}
            role={member?.role}
            className="max-w-96"
          />
        </Modal>
      ) : (
        <BottomSheet open={isEditRole} onDismiss={hndlOpenEditRoleModal}>
          <EditRoleModal
            onSave={hndlEditRole}
            onDemote={hndlDemote}
            user={user}
            role={member?.role}
            className="max-w-96"
          />
        </BottomSheet>
      )}
    </DropdownButton>
  );
};
